import { useState, type VoidFunctionComponent } from 'react';

import Accordion from '../../generic/Accordion';
import Card from '../../generic/Card/Card';

import OrganizationSearch from './OrganizationSearch';

type Props = {
  isOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
};

const OrganizationCard: VoidFunctionComponent<Props> = ({ isOpen, onToggle }) => {
  const [isSectionOpen, setIsSectionOpen] = useState(isOpen ?? false);
  const handleToggle = () => {
    setIsSectionOpen(!isSectionOpen);
    onToggle?.(isSectionOpen);
  };

  return (
    <Card isFullWidth padding="medium">
      <Card.Content>
        <Accordion id="organization-info" isInitiallyOpen={isSectionOpen}>
          <Accordion.Target onClick={handleToggle}>Organization Info</Accordion.Target>
          <Accordion.Body>
            <OrganizationSearch />
          </Accordion.Body>
        </Accordion>
      </Card.Content>
    </Card>
  );
};

export default OrganizationCard;
